import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import { fetchMenus } from '@/actions/menu';
import { fetchMenusTaxonomy, getMenusTaxonomyTitles } from '@/actions/menuTaxonomy';
import PageHeader from '@/components/common/PageHeader';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import MenuCookingListContainer from '@/containers/menus/MenuCookingListContainer';
import MenuTaxonomyCategoryListContainer from '@/containers/menus/MenuTaxonomyCategoryListContainer';
import MenuModalContainer from '@/containers/menus/MenuModalContainer';
import styles from 'styles/jss/original/pages/menus-category/cookingIndex';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { MENU_TAXONOMY_COOKING } from '@/constants/app';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const CookingIndexPage: NextPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.menuCategoryCooking.title}
          description={meta.menuCategoryCooking.description}
          image={meta.menuCategoryCooking.image}
          url={meta.menuCategoryCooking.url}
        />
        <PageHeader type='menuCategoryCooking' />
        <div className={classes.main}>
          <MenuCookingListContainer type={MENU_TAXONOMY_COOKING} />
          <MenuTaxonomyCategoryListContainer />
          <BottomBanner />
        </div>
        <MenuModalContainer />
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await Promise.all([
    (store.dispatch as AppDispatch)(fetchMenus()),
    (store.dispatch as AppDispatch)(fetchMenusTaxonomy()),
    (store.dispatch as AppDispatch)(getMenusTaxonomyTitles(MENU_TAXONOMY_COOKING))
  ]);
});

export default CookingIndexPage;
